module.exports = __webpack_public_path__ + "static/media/right-arrow-v2.c4fb36b0.svg";